import React,{useState,useEffect} from "react";
import {APP_URL, MAIL_ACCOUNT_ALL_LINK} from '../../constants/constants';
import { useGoogleLogin } from '@react-oauth/google';
import {notifySuccess,notifyError} from '../../helper';
import Header from "../Header";
import Footer from "../Footer";
import Sidebar from "../Sidebar";
import client from "../../api";
import BlockLoader from "../BlockLoader";



const ReconnectGoogleMailAccount = () => {
    const api = client();
    const [fname,setFname] = useState();
    const [email,setEmail] = useState();
    const [pageLoader,setPageLoader] = useState(false);
    const reconnectGoogleAccount = useGoogleLogin({
        flow: 'auth-code',
        scope: [
            "https://www.googleapis.com/auth/userinfo.profile",
			"https://www.googleapis.com/auth/userinfo.email",
			"https://www.googleapis.com/auth/gmail.send",
            "https://www.googleapis.com/auth/gmail.readonly",
            "https://www.googleapis.com/auth/gmail.insert"
        ].join(" "),
        ux_mode: "redirect",
        redirect_uri: `${APP_URL}/googlemail-accounts/reconnect`
    });

    const createNewGoogleMailAccount = async (googleCode) => {
        try {
            setPageLoader(true);
            if(googleCode){
                const accountInfo = JSON.parse(localStorage.getItem('reconnect'));
                
                const response = await api.post('/v1/mailAccount/reconnect/google',{
                    name:accountInfo?.name,
                    email:accountInfo?.email,
                    authCode:googleCode,
                    redirectUrl:`${APP_URL}/googlemail-accounts/reconnect`
                });
                if(response.status === 201 || response.status === 200){
                    notifySuccess('New mail successfully account added');
                    localStorage.removeItem('reconnect');
                    
                    setTimeout(()=>{
                        window.location.href = MAIL_ACCOUNT_ALL_LINK;
                    },2000);
                    setPageLoader(true);
                }
            }             
        } catch (error) {
            setPageLoader(false);
          if(error.status === 400){
            notifyError('Bad Request. Not able create a mail account. Please try again');
          }
        }
      };

      useEffect(()=>{
        const query = new URLSearchParams(window.location.search);
        const gcode = query.get('code');
        setEmail(query.get('email'));
        setFname(query.get('name'));
        if(gcode){
            const accountInfo = JSON.parse(localStorage.getItem("reconnect"));
            setFname(accountInfo?.name);
            setEmail(accountInfo?.email);
            createNewGoogleMailAccount(gcode);
        }
    },[]);

    return(<>
        <Header/>
        <div className="main-page">
            <Sidebar/>
            <div className="reconnect-wrap">
            {pageLoader ? <div className="reconnect"><BlockLoader/></div> : <div className="reconnect">
                    <h5>Going to reconnect this account. Please recheck the information mentioned below</h5>
                    <div className="info">
                        <p>Name: <strong>{fname}</strong></p>
                        <p>Email: <strong>{email}</strong></p>
                    </div>
                    <button
                        type="button"
                        className="submit-btn"
                        onClick={()=>{ 
                            localStorage.setItem('reconnect',JSON.stringify({name:fname,email:email}));
                            reconnectGoogleAccount()                 
                        }}>Reconnect</button>
                </div>}
            </div>
        </div>
        <Footer/>
    </>);
}

export default ReconnectGoogleMailAccount;